<template>
  <header>
    <div class="container-fluid hd-top">
      <div class="container">
        <div class="row">
          <div class="col-6 logo">
            <router-link to="/">
              <img src="../assets/images/logo.png" />
            </router-link>
          </div>
          <div class="col-18">
            <div class="r" style="height: 100%">
              <div class="search-box" v-show="showSearchBox">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ custom
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in dropDownData"
                      :key="index"
                      :command="{ value: item.val, label: item.label }"
                      >{{ item.label }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <input
                  type="text"
                  class="uc-input"
                  placeholder="请输入搜索关键字"
                  v-model.trim="keyword"
                  @keyup.enter="handleSearchClick"
                />

                <button
                  class="uc-btn blue"
                  hover-class="none"
                  @click="handleSearchClick"
                >
                  <i class="uc-font uc-search"></i>
                </button>
              </div>
              <router-link :to="{ name: 'MessageCenter' }" class="btns">
                <img
                  src="../assets/images/icon-bell.png"
                  class="uc-icon32"
                  alt="查看更多消息"
                  title="查看更多消息"
                />
              </router-link>
              <a
                :href="adminUrl"
                target="_self"
                class="btns"
                v-if="this.$store.getters.user.is_admin"
              >
                <img
                  src="../assets/images/icon-manage.png"
                  class="uc-icon32"
                  alt="进入管理端"
                  title="进入管理端"
                />
              </a>
              <div class="btns-user">
                <img src="../assets/images/icon-person.png" class="uc-icon32" />
                <div class="menu-box">
                  <div class="menu-con">
                    <router-link
                      class="menu-item"
                      :to="{ name: 'PersonalStudy' }"
                    >
                      <span class="el-icon-user"> 个人中心</span>
                    </router-link>
                    <router-link
                      class="menu-item"
                      :to="{ name: 'PersonalCenter' }"
                    >
                      <span class="el-icon-setting"> 基本信息</span>
                    </router-link>
                    <a class="menu-item" href="javascript:;;" @click="logout">
                      <span class="el-icon-switch-button"> 退出登录</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid hd-menu" :class="isFixedHeader ? 'fixed' : ''">
      <div class="container">
        <div class="row">
          <ul class="col-24 list">
            <li
              v-for="(item, index) in list"
              :key="index"
              class="item"
              :class="code == item.code ? 'on' : ''"
            >
              <router-link
                :to="{ name: item.path }"
                v-html="item.name"
              ></router-link>
              <div class="subMenu" v-if="item.children.length > 0">
                <div class="con">
                  <router-link
                    :to="{ name: item2.path }"
                    v-for="(item2, index2) in item.children"
                    :key="index2"
                    >{{ item2.name }}</router-link
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="hd-menu-fill" v-show="isFixedHeader"></div>
  </header>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'TopHeader',
  props: {
    code: {
      type: String,
      default: 'home',
    },
    showSearchBox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMINURL,
      keyword: this.$route.query.keyword,
      isFixedHeader: false,
      list: [
        { name: '首页', path: 'Home', children: [], code: 'home' },
        {
          name: '学习',
          path: 'StudyCourse',
          children: [],
          code: 'study',
        },
        {
          name: '课程',
          path: 'Course',
          children: [],
          code: 'course',
        },
        {
          name: '培训',
          path: '',
          children: [
            { name: '专题', path: 'TrainClass' },
            { name: '培训相册', path: 'TrainAlbum' },
            // { name: '师徒系统', path: 'Shitu' },
          ],
          code: 'train',
        },
        {
          name: '直播',
          path: 'Live',
          children: [],
          code: 'live',
        },
        {
          name: '知识',
          path: '',
          children: [
            { name: '知识库', path: 'UserKnowledge' },
            // { name: '案例库', path: 'Knowledge' },
            { name: '百科', path: 'KnowPoint' },
          ],
          code: 'know',
        },
        {
          name: '社区',
          path: 'Topic',
          children: [],
          code: 'topic',
        },
        {
          name: '应用',
          path: '',
          children: [
            { name: '讲师风采', path: 'Lecturer' },
            { name: '积分商城', path: 'Mall' },
          ],
          code: 'app',
        },
      ],
      dropDownData: [
        // { label: '智能检索', val: 0 },
        { label: '最新', val: 1 },
        { label: '最热', val: 2 },
      ],
      custom: '最新',
      orderby: 1,
    };
  },
  created() {
    window.addEventListener(
      'scroll',
      () => {
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop >= 112) {
          this.isFixedHeader = true;
        } else {
          this.isFixedHeader = false;
        }
      },
      true
    );
  },
  methods: {
    handleSearchClick() {
      if (!this.keyword) {
        this.$message({ type: 'warning', message: '请输入搜索关键字' });
      } else {
        // 带参数跳转
        this.$router.push({
          name: 'Search',
          query: { keyword: this.keyword, orderby: this.orderby },
        });
      }
    },
    // 退出登录
    logout() {
      localStorage.removeItem('Authorization');
      localStorage.removeItem('CurrentUser');
      location.href = `${
        process.env.VUE_APP_PASSPORT_LOGOUTURL
      }?returnUrl=${encodeURIComponent(location.href)}`;
    },
    handleCommand(command) {
      this.custom = command.label;
      this.orderby = command.value;
    },
  },
});
</script>
